export default "__VITE_ASSET__DbzGK1ob__"